import { IConfig } from '@cian/config/shared';

const DEFAULT_COMMON_CATEGORY_ID_TO_LABEL: ICommonCategoryIdToLabel = {};
const COMMON_CATEGORY_LABEL_FALLBACK = 'serializeCommonCategory';

export interface ICommonCategoryIdToLabel {
  [key: string]: string;
}

export function getCommonCategoryIdToLabel(config: IConfig): ICommonCategoryIdToLabel {
  const mapping = config.get<ICommonCategoryIdToLabel>('subscriptions-frontend.tracking.commonCategoryIdToLabel');

  return mapping || DEFAULT_COMMON_CATEGORY_ID_TO_LABEL;
}

export function getCommonCategoryLabel(categoryId: number, config: IConfig) {
  const mapping = getCommonCategoryIdToLabel(config);
  const item = mapping[categoryId];

  return item || COMMON_CATEGORY_LABEL_FALLBACK;
}
